export default {
  inserted: (el, binding) => execExpression(el, binding),
  update: (el, binding) => execExpression(el, binding)
}

function execExpression (el, binding) {
  let {value, oldValue} = binding
  if (value != oldValue) {
    let line = ''
    line = (value.map(v => '<span class="val">' + v.name + '</span>')).join('<span class="del">, </span>')
    el.innerHTML = line
  }
}
